
import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Card as MuiCard,
  CardMedia,
  CardContent,
  Stack
} from "@mui/material";
import { styled } from "@mui/system";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FilterDataCard from "../../components/common/FilterDataCard";
import PlotSlider from "../../components/common/FeaturedCard";
import BreadcrumbsNav from "../../components/common/BreadCrumbNav";
import GiooPlot_card from "../../components/common/GiooPlot-card";
import { useNavigate } from "react-router-dom";
import { get_geo_fun } from "../../api/ControllApi";
import { Skeleton } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";
import GiooGridView from "./GiooGridView";
import { useSettings } from "../../context/Settings";
import DescriptionNote from "../../components/common/DescriptionNote";

const Card = styled(MuiCard)(({ theme }) => ({
  maxWidth: 345,
  margin: "auto",
  borderRadius: theme.spacing(2),
  overflow: "hidden",
}));

export default function GiooPlot() {
  const { settings } = useSettings();
  const [geoPlots, setGeoPlot] = useState([]);
  const [view, setView] = useState("grid");
  const [propertyType, setPropertyType] = useState([])
  const [resp, setResp] = useState([])
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });

  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);


  const [loading, setLoading] = useState(true);

  // const geoData = () => {
  //   setLoading(true);
  //   get_geo_fun()
  //     .then((res) => {
  //       setResp(res?.data);
  //       setGeoPlot(res?.data.geo || []);
  //       setPropertyType(res?.data?.property_type)

  //     })
  //     .catch((err) => {

  //       setGeoPlot([]);
  //     })
  //     .finally(() => {
  //       setLoading(false); // stop loading
  //     });
  // };

  // useEffect(() => {
  //   geoData();
  // }, []);

  const fetchGeoPlots = async (filters = {}, page = 1) => {
    setLoading(true);

    try {
      const params = {};

      // only add a param if it has a value
      if (filters.states) params.state = filters.states;
      if (filters.city) params.city = filters.city;
      // if (filters.plotType) params.plot_type = filters.plotType;
      if (filters.plotType && filters.plotType.length > 0) {
        params['plot_type[]'] = filters.plotType; // send array directly
      }




      if (filters.priceRange && filters.priceRange.length === 2) {
        // send only if user changed from undefined
        params.min_price = filters.priceRange[0];
        params.max_price = filters.priceRange[1];
      }

      if (filters.areaRange && filters.areaRange.length === 2) {
        params.min_sqft = filters.areaRange[0];
        params.max_sqft = filters.areaRange[1];
      }

      if (filters.searchQuery?.trim()) params.search = filters.searchQuery.trim();

      // Only log params that are actually sent

      const res = Object.keys(params).length > 0 || page > 0
        ? await get_geo_fun(params, page) // send params if any
        : await get_geo_fun();      // initial load → no params

      setResp(res?.data);
      setGeoPlot(res?.data?.geo || []);
      setPropertyType(res?.data?.property_type || []);
      setPagination(
        res?.data?.pagination || { current_page: 1, last_page: 1 }
      );
    } catch (err) {

      setGeoPlot([]);
    } finally {
      setLoading(false);
    }
  };






  useEffect(() => {
    fetchGeoPlots(filters, page);
  }, [filters, page]);


  const handlePageChange = (page) => {
    setPage(page);
    setPagination((prev) => ({ ...prev, current_page: page }));
    window.scrollTo({ top: 0, behavior: "smooth" });
    // fetchGeoPlots({}, page);
  };






  // const handleFilterChange = useCallback((filters) => {
  //   fetchGeoPlots(filters, 1);
  // }, []);
  const handleFilterChange = useCallback((newFilters) => {
    setFilters(newFilters);
    setPage(1);
  }, []);



  return (
    <Container sx={{ py: 5 }}>
      <Box sx={{ mb: 2 }}>
        <BreadcrumbsNav />
      </Box>
      {settings?.data?.gioonano_description && (
        <DescriptionNote description={settings.data.gioonano_description} />
      )}

      {/* View toggle */}
      <Box display="flex" justifyContent="flex-end" mr={1.5}>
        <IconButton color={view === "grid" ? "primary" : "default"} onClick={() => setView("grid")}>
          <Box
            key={view === "grid" ? "grid-active" : "grid-idle"}
            component="span"
            sx={{
              display: "flex",
              ...(view === "grid" && {
                animation: "iconPop 0.28s ease",
                "@keyframes iconPop": {
                  "0%": { transform: "scale(0.55) rotate(-20deg)", opacity: 0.4 },
                  "65%": { transform: "scale(1.22)", opacity: 1 },
                  "100%": { transform: "scale(1) rotate(0deg)", opacity: 1 },
                },
              }),
            }}
          >
            <ViewModuleIcon />
          </Box>
        </IconButton>
        <IconButton color={view === "list" ? "primary" : "default"} onClick={() => setView("list")}>
          <Box
            key={view === "list" ? "list-active" : "list-idle"}
            component="span"
            sx={{
              display: "flex",
              ...(view === "list" && {
                animation: "iconPop 0.28s ease",
                "@keyframes iconPop": {
                  "0%": { transform: "scale(0.55) rotate(20deg)", opacity: 0.4 },
                  "65%": { transform: "scale(1.22)", opacity: 1 },
                  "100%": { transform: "scale(1) rotate(0deg)", opacity: 1 },
                },
              }),
            }}
          >
            <ViewListIcon />
          </Box>
        </IconButton>
      </Box>

      <Box
        sx={{
          display: { sm: "block", lg: "flex" },
          gap: 0.5,
          alignItems: "flex-start",
          position: "relative",
          minHeight: "100vh",
        }}
      >
        {/* Filter */}
        <Box
          sx={{
            width: { xs: "80%", sm: "50%", lg: 0 },
            mx: "auto",
            flex: { xs: "0 0 50%", sm: "0 0 50%", md: "0 0 22%" },
            position: { xs: "static", lg: "sticky" },
            top: { md: 115 },
            mb: { xs: 2, md: 0 },
            mt: { xs: 1 },
            zIndex: 10,
            alignSelf: "flex-start",
            height: "fit-content",
          }}
        >
          <FilterDataCard
            onFilterChange={handleFilterChange}
            PropertyType={propertyType}
            priceMax={resp?.price_max}
            priceMin={resp?.price_min}
            stateList={resp?.state_list}
            areaMax={resp?.sqft_max}
            areaMin={resp?.sqft_min}
          />
        </Box>

        {/* Data section */}

        <Box
          key={view}
          sx={{
            flex: 1,
            display: "grid",
            gridTemplateColumns:
              view === "grid"
                ? {
                  xs: "1fr",
                  sm: "0.5fr 0.5fr",
                  md: "1fr 1fr",
                  lg: "1fr 1fr",
                }
                : {
                  xs: "1fr",
                  sm: "1fr",
                  md: "1fr 1fr",
                  lg: "1fr",
                },
            gap: 1,
            ml: { xs: 0, lg: 8 },
            mt: { xs: 3, lg: 0 },
            px: 2,
            py: 2,
            // container entrance
            animation: "viewEnter 0.35s cubic-bezier(0.34,1.2,0.64,1) both",
            "@keyframes viewEnter": {
              "0%": { opacity: 0, transform: "scale(0.97) translateY(14px)" },
              "60%": { opacity: 1, transform: "scale(1.005) translateY(-2px)" },
              "100%": { opacity: 1, transform: "scale(1) translateY(0)" },
            },
            // stagger each direct child card
            "& > *": {
              animation: "cardSlideIn 0.42s cubic-bezier(0.34,1.2,0.64,1) both",
              "@keyframes cardSlideIn": {
                "0%": { opacity: 0, transform: "translateY(20px) scale(0.96)" },
                "70%": { opacity: 1, transform: "translateY(-3px) scale(1.01)" },
                "100%": { opacity: 1, transform: "translateY(0) scale(1)" },
              },
            },
            "& > *:nth-of-type(1)": { animationDelay: "0.04s" },
            "& > *:nth-of-type(2)": { animationDelay: "0.09s" },
            "& > *:nth-of-type(3)": { animationDelay: "0.14s" },
            "& > *:nth-of-type(4)": { animationDelay: "0.19s" },
            "& > *:nth-of-type(5)": { animationDelay: "0.24s" },
            "& > *:nth-of-type(6)": { animationDelay: "0.29s" },
            "& > *:nth-of-type(n+7)": { animationDelay: "0.32s" },
          }}
        >
          {loading ? (
            Array.from(new Array(4)).map((_, index) => (
              view != "grid" ?
                <Box
                  key={index}
                  sx={{
                    width: "100%",
                    maxWidth: 780,
                    minHeight: { xs: 150, md: 200 },
                    backgroundColor: "#f0f0f0",
                    borderRadius: 5,
                    display: "flex",
                    flexDirection: { xs: "column-reverse", lg: "row" },
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: { xs: 2, md: 5 },
                    ml: { xs: 0, lg: 4 },
                    py: { xs: 4, md: 3 },
                    gap: { xs: 2, md: 3 },
                  }}
                >
                  <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
                    <Skeleton variant="text" width="60%" height={30} />
                    <Skeleton variant="text" width="40%" height={20} />
                    <Skeleton variant="text" width="80%" height={20} />
                    <Skeleton variant="rectangular" width="100px" height={40} />
                  </Box>

                  <Box
                    sx={{
                      width: { xs: "100%", md: "50%" },
                      maxWidth: 400,
                      aspectRatio: "4/3",
                      borderRadius: 2,
                      overflow: "hidden",
                    }}
                  >
                    <Skeleton variant="rectangular" width="100%" height="100%" />
                  </Box>
                </Box>
                :
                <Card
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "column" },
                    borderRadius: 4,
                    p: 1,
                    overflow: "hidden",
                    width: "100%",
                    mx: "auto",
                    gap: 4,
                  }}
                >
                  {/* LEFT IMAGE SKELETON */}
                  <Skeleton
                    variant="rectangular"
                    sx={{
                      width: { xs: "100%", sm: 330 },
                      height: { xs: 180, sm: 220 },
                      borderRadius: 3,
                    }}
                    animation="wave"
                  />

                  {/* RIGHT SIDE SKELETON */}
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      py: 1,
                    }}
                  >
                    <Box>
                      <Skeleton variant="text" width="60%" height={28} animation="wave" />
                      <Skeleton variant="text" width="40%" height={22} animation="wave" sx={{ mt: 1 }} />
                      <Skeleton variant="text" width="50%" height={28} animation="wave" sx={{ mt: 2 }} />
                      <Skeleton variant="text" width="30%" height={20} animation="wave" sx={{ mt: 1 }} />
                    </Box>

                    {/* Button Skeleton */}
                    <Skeleton
                      variant="rectangular"
                      height={42}
                      animation="wave"
                      sx={{
                        borderRadius: 2,
                        mt: 2,
                      }}
                    />
                  </Box>
                </Card>
            ))
          ) : geoPlots.length === 0 ? (
            <Box
              sx={{
                gridColumn: "1 / -1", // span all columns of the grid
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "60vh",
                textAlign: "center",
                width: "100%",
                py: 5,
              }}
            >
              <Box
                component="img"
                src="/assets/images/nodatafound.png"
                alt="No Data Found"
                sx={{ width: { xs: 320, sm: 350, md: 380 }, mb: 2 }}
              />
              {/* Optional text */}
              {/* <Typography variant="subtitle1" color="text.secondary">
      No Data Found
    </Typography> */}
            </Box>
          ) : (
            geoPlots.map((card) => (
              <Box sx={{ mb: 1.5 }} key={card.id}>
                {view === "grid" ? (
                  <GiooGridView
                    id={card.id}
                    image={card?.image?.[0]}
                    price={card?.price}
                    totalAmount={card?.total_price}
                    nearBy={card?.nearby_locations}
                    totalPrice={card?.area}
                    address={card?.address || `${card?.city?.city_name || "Chennai"}, ${card?.state?.state_name || "TamilNadu"}`}
                    name={card?.name}
                    amenity={card?.amenity}
                    hideNearBy={false}
                    hideAmenities={false}
                    soldStatus={card?.sold_status}
                  />
                ) : (
                  <GiooPlot_card
                    id={card.id}
                    totalAmount={card?.total_price}
                    name={card?.name}
                    amenity={card?.amenity}
                    address={card?.address || `${card?.city?.city_name || "Chennai"}, ${card?.state?.state_name || "TamilNadu"}`}
                    nearBy={card?.nearby_locations}
                    created={card?.created_at}
                    image={card?.image?.[0]}
                    plotImage={card?.plot_image}
                    totalPrice={card?.area}
                    price={card?.price}
                    soldStatus={card?.sold_status}
                  />
                )}
              </Box>
            ))
          )}
        </Box>
      </Box>

      {/* Pagination */}
      {geoPlots.length > 0 && pagination.last_page > 1 && (<Stack direction="row" spacing={1} justifyContent="center" mt={5}>
        {Array.from({ length: pagination.last_page }, (_, i) => i + 1).map(
          (page) => (
            <Button
              key={page}
              variant={
                page === pagination.current_page ? "contained" : "outlined"
              }
              onClick={() => handlePageChange(page)}
            >
              {page}
            </Button>
          )
        )}
      </Stack>)}
    </Container>
  );

}


// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Container,
//   Grid,
//   Typography,
//   Button,
//   Card as MuiCard,
//   CardMedia,
//   CardContent,
// } from "@mui/material";
// import { styled } from "@mui/system";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import FilterDataCard from "../../components/common/FilterDataCard";
// import PlotSlider from "../../components/common/FeaturedCard";
// import BreadcrumbsNav from "../../components/common/BreadCrumbNav";
// import GiooPlot_card from "../../components/common/GiooPlot-card";
// import { useNavigate } from "react-router-dom";
// import { get_geo_fun } from "../../api/ControllApi";
// import { Skeleton } from "@mui/material";


// const Card = styled(MuiCard)(({ theme }) => ({
//   maxWidth: 345,
//   margin: "auto",
//   borderRadius: theme.spacing(2),
//   overflow: "hidden",
// }));

// export default function GiooPlot() {
//   const [geoPlots, setGeoPlot] = useState([]);

//   const [loading, setLoading] = useState(true);


//   const geoData = () => {
//     setLoading(true);
//     get_geo_fun()
//       .then((res) => {
//         setGeoPlot(res?.data.geo || []);
//       })
//       .catch((err) => {

//         setGeoPlot([]);
//       })
//       .finally(() => {
//         setLoading(false); // stop loading
//       });
//   };

//   useEffect(() => {
//     geoData();
//   }, []);



//   return (
//     <Container sx={{ py: 5 }}>
//       <Box sx={{ mb: 3 }}>
//         <BreadcrumbsNav />
//       </Box>

//       <Box
//         sx={{
//           display: { sm: "block", md: "flex" },
//           gap: 3,
//           alignItems: "flex-start",
//         }}
//       >
//         <Box
//           sx={{
//             flex: "0 0 33%",
//             position: { sm: "static", md: "sticky" },
//             top: 80,
//           }}
//         >
//           <FilterDataCard />
//         </Box>

//         <Box
//           sx={{
//             flex: 1,
//             display: "grid",
//             gridTemplateColumns: { xs: "1fr", sm: "1fr" },
//             gap: 2,
//             px: 2,
//             py: 2,
//           }}
//         >
//           {loading ? (
//             // Render 4 skeleton cards
//             Array.from(new Array(4)).map((_, index) => (
//               <Box
//                 key={index}
//                 sx={{
//                   width: "100%",
//                   maxWidth: 950,
//                   minHeight: { xs: 300, md: 400 },
//                   backgroundColor: "#f0f0f0", // light background for skeleton
//                   borderRadius: 5,
//                   display: "flex",
//                   flexDirection: { xs: "column-reverse", md: "row" },
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   px: { xs: 2, md: 5 },
//                   py: { xs: 4, md: 3 },
//                   gap: { xs: 2, md: 3 },
//                   overflow: "hidden",
//                 }}
//               >
//                 {/* Left side shimmer */}
//                 <Box
//                   sx={{
//                     flex: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: 2,
//                   }}
//                 >
//                   <Skeleton variant="text" width="60%" height={30} />
//                   <Skeleton variant="text" width="40%" height={20} />
//                   <Skeleton variant="text" width="80%" height={20} />
//                   <Skeleton variant="rectangular" width="100px" height={40} />
//                 </Box>

//                 {/* Right side image shimmer */}
//                 <Box
//                   sx={{
//                     width: { xs: "100%", md: "50%" },
//                     maxWidth: 400,
//                     aspectRatio: "4/3",
//                     borderRadius: 2,
//                     overflow: "hidden",
//                     alignSelf: "center",
//                   }}
//                 >
//                   <Skeleton variant="rectangular" width="100%" height="100%" />
//                 </Box>
//               </Box>
//             ))
//           ) : geoPlots.length === 0 ? (
//             <Typography variant="h6" sx={{ textAlign: "center", width: "100%" }}>
//               No Data Available
//             </Typography>
//           ) : (
//             // Render actual data cards
//             geoPlots.map((card, index) => (
//               <GiooPlot_card
//                 key={index}
//                 name={card?.name}
//                 address={card?.city.city_name}
//                 state={card?.state.state_name}
//                 image={card?.image}
//                 plotImage={card?.plot_image}
//                 price={card?.price}
//                 id={card?.id}
//               />
//             ))
//           )}
//         </Box>

//       </Box>
//     </Container>
//   );
// }
